import { render, staticRenderFns } from "./top-nav-right-btns.vue?vue&type=template&id=2640b9bd&scoped=true&"
import script from "./top-nav-right-btns.vue?vue&type=script&lang=js&"
export * from "./top-nav-right-btns.vue?vue&type=script&lang=js&"
import style0 from "./top-nav-right-btns.vue?vue&type=style&index=0&id=2640b9bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640b9bd",
  null
  
)

export default component.exports